import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqData = [
  {
    question: "Is my money safe?",
    answer:
      "Yes. Client funds are held in segregated accounts and protected by strict regulatory standards. We never use client deposits for company operations or trading. Security, transparency, and fund protection are core to our values.",
    answer1:
      "For more details, please review our legal documentation relevant to your jurisdiction or contact our support team anytime.",
  },
  {
    question: "What is the minimum deposit?",
    answer:
      "The minimum deposit starts at just $10, depending on the account type.",
    answer1:
      "We offer flexible options to suit all traders — from beginners to professionals. Terms and conditions apply.",
  },
  {
    question: "Do you offer a demo account for practice?",
    answer: "Yes, we offer a free demo account with virtual funds.",
    answer1:
      "To get started, simply log in to our client portal and create your demo account in seconds. It’s the ideal way to explore the platform, test strategies, and build confidence — all without any financial risk.",
  },
  {
    question: "What trading platforms do you support?",
    answer: "Yes, we offer a free demo account with virtual funds.",
    answer1:
      "Trade seamlessly across desktop, web, and mobile — with advanced charting tools, fast execution, and complete control at your fingertips.",
  },
  {
    question: "Are there any hidden fees or commissions?",
    answer: "No hidden fees — ever.",
    answer1:
      "All our pricing, including spreads, swaps, and any commissions, is fully transparent and clearly displayed before you trade. We believe in honest, upfront costs so you can trade with confidence. Terms and conditions apply.",
  },
];

const Faq = () => {
  const [expanded, setExpanded] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const visibleFaqs = showAll ? faqData : faqData.slice(0, 5);

  return (
    <Container maxWidth="md" sx={{ py: 13 }}>
      <Typography variant="h2" align="center" fontWeight="bold" sx={{ mb: 8 }}>
        Frequently Asked Questions
      </Typography>

      {visibleFaqs.map((faq, index) => (
        <Accordion
          key={index}
          expanded={expanded === index}
          onChange={handleChange(index)}
          sx={{
            mb: 2,
            borderRadius: 2,
            boxShadow: "none",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{ px: 2 }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <img
                  src="/Images/faqIcon.png"
                  alt="FAQ Icon"
                  style={{ width: 50, height: 50 }}
                />
              </Box>
              <Typography fontWeight={600} fontSize="1.2rem">
                {faq.question}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 10, color: "#667085" }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: "16px",

                fontFamily: "SF Pro Display",
                mt: "-14px",
              }}
            >
              {faq.answer}
            </Typography>
            {faq.answer1 && (
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "SF Pro Display",
                  paddingTop: '5px'
                  // mt: "-10px",
                }}
              >
                {faq.answer1}
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>
      ))}

      {/* Uncomment this button if you add more than 5 FAQs */}
      {/* <Box textAlign="center" mt={4}>
        <Button
          variant="contained"
          onClick={() => setShowAll(!showAll)}
          sx={{
            borderRadius: 2,
            backgroundColor: "#000",
            color: "#fff",
            px: 4,
            py: 1,
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#333",
            },
          }}
        >
          {showAll ? "Load Less" : "Load More"}
        </Button>
      </Box> */}
    </Container>
  );
};

export default Faq;
